import { alpha } from "@mui/material/styles";
import { GREY, PRIMARY, SECONDARY, INFO, SUCCESS, WARNING, ERROR } from "./colors";

function createGradient(color1: string, color2: string) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info:    createGradient(INFO.light,    INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error:   createGradient(ERROR.light,   ERROR.main),
};

const CHART_COLORS = {
  violet: ["#818CF8", "#A78BFA", "#C4B5FD", "#DDD6FE"],
  blue:   ["#38BDF8", "#7DD3FC", "#BAE6FD", "#E0F2FE"],
  green:  ["#34D399", "#6EE7B7", "#A7F3D0", "#D1FAE5"],
  yellow: ["#FCD34D", "#FDE68A", "#FEF3C7", "#FFFBEB"],
  red:    ["#FB7185", "#FDA4AF", "#FECDD3", "#FFE4E6"],
};

const grey = {
  ...GREY,
  500_8:  alpha(GREY[500], 0.08),
  500_12: alpha(GREY[500], 0.12),
  500_16: alpha(GREY[500], 0.16),
  500_24: alpha(GREY[500], 0.24),
  500_32: alpha(GREY[500], 0.32),
  500_48: alpha(GREY[500], 0.48),
  500_56: alpha(GREY[500], 0.56),
  500_80: alpha(GREY[500], 0.80),
};

export type IGreyType = typeof grey;

export const palette = {
  common: { black: "#000", white: "#fff" },
  primary:   { ...PRIMARY },
  secondary: { ...SECONDARY },
  info:      { ...INFO },
  success:   { ...SUCCESS },
  warning:   { ...WARNING },
  error:     { ...ERROR },
  grey,
  gradients: GRADIENTS,
  chart:     CHART_COLORS,
  divider:   alpha(GREY[500], 0.24),
  text: {
    primary:   GREY[800],
    secondary: GREY[600],
    disabled:  GREY[500],
  },
  background: {
    paper:   "#fff",
    default: GREY[100],
    neutral: GREY[200],
  },
  action: {
    active:             GREY[600],
    hover:              alpha(GREY[500], 0.08),
    selected:           alpha(GREY[500], 0.16),
    disabled:           alpha(GREY[500], 0.80),
    disabledBackground: alpha(GREY[500], 0.24),
    focus:              alpha(GREY[500], 0.24),
    hoverOpacity:       0.08,
    disabledOpacity:    0.48,
  },
};
